var map = {
	"./1.svg": 2697,
	"./10.svg": 5952,
	"./11.svg": 6330,
	"./12.svg": 2031,
	"./13.svg": 8040,
	"./14.svg": 7717,
	"./15.svg": 7870,
	"./2.svg": 3347,
	"./3.svg": 4479,
	"./4.svg": 8605,
	"./5.svg": 1134,
	"./6.svg": 4186,
	"./7.svg": 1033,
	"./8.svg": 7078,
	"./9.svg": 5944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3153;